import {
  CONFIRM_SELECTED_RESULT,
  CONFIRM_SELECTED_HOTEL,
} from '../helpers/constants/actionsConstants';

import type { NextFn } from './types';
import type { AnyAction } from 'redux';

export type onConfirmResultFn = (
  outboundDate: Date,
  inboundDate: Date,
  preferDirects: boolean,
  departureTimeRange?: string,
) => void;

export type onConfirmHotelFn = (
  checkinDate: Date,
  checkoutDate: Date,
  destinationId: string,
  impressionId: string,
) => void;

export const navigationMiddleware =
  (
    // eslint-ignore no-unused-vars
    store: unknown, // probably a redux Store but never used so it doesn't matter
    onSelectedResultConfirmed: onConfirmResultFn,
    onSelectedHotelConfirmed: onConfirmHotelFn,
  ) =>
  (next: NextFn) =>
  (action: AnyAction) => {
    next(action);
    if (action.type === CONFIRM_SELECTED_RESULT) {
      onSelectedResultConfirmed(
        action.payload.outboundDate,
        action.payload.inboundDate,
        action.payload.preferDirects,
        action.payload.departureTimeRange,
      );
    } else if (action.type === CONFIRM_SELECTED_HOTEL) {
      onSelectedHotelConfirmed(
        action.payload.checkinDate,
        action.payload.checkoutDate,
        action.payload.destinationId,
        action.payload.impressionId,
      );
    }
  };
